import React from 'react';

export default function CompaniesTable({ shippingCompanies, onCompanyUpdateOrDelete }) {
	return (
		<div className="table-view table-responsive" id="setting-tables">
			<table id="companies-table" className="table">
				<thead>
					<tr>
						<th>Company Name</th>
						<th>Obsolete</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody>
					{shippingCompanies
						? shippingCompanies.map(company => (
								<tr key={company.id}>
									<td>{company.companyName}</td>
									<td>
										<div className="checkbox">
											<input
												disabled
												checked={company.obsolete === '1' ? 'checked' : ''}
												type="checkbox"
											/>
										</div>
									</td>
									<td>
										<i
											data-toggle="modal"
											data-target="#confirmationModal"
											className="fa fa-trash-o icon"
											onClick={() => onCompanyUpdateOrDelete(company)}
										/>
										<i
											data-toggle="modal"
											data-target="#oneInputEditModal"
											className="fa fa-pencil-square-o icon"
											onClick={() => onCompanyUpdateOrDelete(company)}
										/>
									</td>
								</tr>
						  ))
						: null}
				</tbody>
			</table>
		</div>
	);
}
